<template>
  <div>
    <serviceList
      :bannerUrl="bannerUrl"
      :bannerTitle="$t('interactivePlatformPage.bannerTitle')"
      :bannerText="$t('interactivePlatformPage.bannerText')"
      :characterList="characterList"
      :imgTextList="imgTextList"
      isRightPostion
    />
  </div>
</template>

<script setup>
import serviceList from '../../components/template/serviceList.vue';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const bannerUrl = require('@assets/images/banner/banner-interactive-platform.png');
const characterList = [
  {
    img: require('@assets/icons/ico-interactive-platform_1.svg'),
    title: t('interactivePlatformPage.feature1.title'),
    text: t('interactivePlatformPage.feature1.text'),
  },
  {
    img: require('@assets/icons/ico-interactive-platform_2.svg'),
    title: t('interactivePlatformPage.feature2.title'),
    text: t('interactivePlatformPage.feature2.text'),
  },
  {
    img: require('@assets/icons/ico-interactive-platform_3.svg'),
    title: t('interactivePlatformPage.feature3.title'),
    text: t('interactivePlatformPage.feature3.text'),
  },
]
const imgTextList = [
  {
    img: require('@assets/images/interactive_platform_1.png'),
    title: t('interactivePlatformPage.description1.title'),
    text: t('interactivePlatformPage.description1.text'),
  },
  {
    img: require('@assets/images/interactive_platform_2.png'),
    title: t('interactivePlatformPage.description2.title'),
    text: t('interactivePlatformPage.description2.text'),
  },
]
</script>